import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCustomerSettings, getLanguages } from 'modules/settings/api';

export const useQueryCustomerSettings = (userId?: number) => {
  // Fetching profile info
  const {
    error: errCompanySettings,
    data: dataCompanySettings,
    isLoading: isLoadingCompanySettings,
  } = useQuery(QUERY_KEYS.SETTINGS_CUSTOMER_SETTINGS, () => getCustomerSettings(userId as number), {
    cacheTime: 0,
  });

  const {
    error: errLanguages,
    data: dataLanguages,
    isLoading: isLoadingLanguages,
  } = useQuery(QUERY_KEYS.SETTINGS_LANGUAGES, () => getLanguages());

  return {
    isLoadingCustomerSettings: isLoadingCompanySettings || isLoadingLanguages,
    isError: errCompanySettings || errLanguages,
    settings: dataCompanySettings?.data || null,
    languages: dataLanguages?.data || null,
  };
};
